import GitGubImg from '../../../../assets/images/certificates/GitGitHub.png';
import JavascriptImg from '../../../../assets/images/certificates/Javascript.png';
import MySQLImg from '../../../../assets/images/certificates/MySQL.png';
import OminStackImg from '../../../../assets/images/certificates/OminStack.png';
import UnityImg from '../../../../assets/images/certificates/Unity3d.png';

import GitGubPdf from "../../../../assets/doc/Certificates/Course/Vinicius-Zapala-dos-Santos-Git-e-GitHub-20-Horas-Certificado-Curso-em-Video.pdf"
import JavascriptPdf from "../../../../assets/doc/Certificates/Course/Vinicius-Zapala-dos-Santos-Javascript-40-Horas-Certificado-Curso-em-Video.pdf"
import MySQLPdf from "../../../../assets/doc/Certificates/Course/Vinicius-Zapala-dos-Santos-MySQL-40-Horas-Certificado-Curso-em-Video.pdf"
import OminStackPdf from "../../../../assets/doc/Certificates/Course/jornada-da-Semana-OmniStack-11.pdf"
import UnityPdf from  "../../../../assets/doc/Certificates/Course/Aprenda-Unity-3D-Projeto-Zelda.pdf"


export const icon = {
  GitGubImg,
  JavascriptImg,
  MySQLImg,
  OminStackImg,
  UnityImg,
}


export const pdf = {
  GitGubPdf,
  JavascriptPdf,
  MySQLPdf,
  OminStackPdf,
  UnityPdf,
}